module.exports = __webpack_public_path__ + "static/media/ask_help.011042a4.svg";